import React from 'react';
import RefreshIcon from '@mui/icons-material/Refresh';
import { Button, Paper, Stack, Typography } from '@mui/material';
import PropTypes from 'prop-types';
const NoData = ({ title = 'No data available', subTitle = '', subTitleClass = '', handleSubTitleClick = () => { }, handleRefresh = () => { } }) => {
  return (
    <Paper elevation={0} sx={{ height: 'calc(100vh - 330px)' }} className='w-full mt-12 text-center flex-col justify-between flex items-center'>
      <Stack direction='column' justifyContent={'center'} alignItems='center' spacing={3}>
        <Typography variant="h5" className='text-border'>
          {title}
          <span className={`block text-center`} >Keep bidding!</span>
          <span className={`block text-center ${subTitleClass}`} onClick={handleSubTitleClick}>{subTitle}</span>
        </Typography>
        <Button onClick={handleRefresh} className='w-36 py-3 text-text hover:bg-light-border bg-light-border' startIcon={<RefreshIcon />}>
          Refresh
        </Button>
      </Stack>
    </Paper>
  );
};

NoData.propTypes = {
  title: PropTypes.string,
  subTitle: PropTypes.string,
  subTitleClass: PropTypes.string,
  handleSubTitleClick: PropTypes.func,
  handleRefresh: PropTypes.func
};

export default NoData;